export type autoCompleteKeys =
  | 'openSearch'
  | 'companySearch'
  | 'departmentSearch'
  | 'educationSearch'
  | 'schoolSearch'
  | 'tagSearch'
  | 'titleSearch'
  | 'titleSearchV2'
  | 'experienceSearch'
  | 'languageSearch'
  | 'userSearch'
  | 'opportunitySearch'
  | 'opportunityFieldSearch'
  | 'jobStructure'
  | 'successorsTemplateSearch'
  | 'peopleSearch'
  | 'industriesSearch'
  | 'certificationSearch'
  | 'locationSearch';

type TAutoCompleteTypes = {
  [key in autoCompleteKeys | 'locationSearch']: {
    url: string;
    query?: any;
    name?: string;
  };
};

const autoCompleteTypes: TAutoCompleteTypes = {
  openSearch: {
    url: '/api/v1/autocomplete/search-user-field',
  },
  companySearch: {
    url: '/api/v1/autocomplete/companies',
  },
  departmentSearch: {
    url: '/api/v1/autocomplete/departments',
  },
  educationSearch: {
    url: '/api/v1/autocomplete/education',
  },
  schoolSearch: {
    url: '/admin/lookups/ajax_lookup/school',
  },
  tagSearch: {
    url: '/api/v1/tags/lookup',
  },
  titleSearch: {
    url: '/api/v1/autocomplete/title',
  },
  titleSearchV2: {
    url: '/api/v1/autocomplete/titles-v2',
  },
  locationSearch: {
    url: '/api/v1/autocomplete/location',
    query: { type: ['CO', 'CI'] },
  },
  experienceSearch: {
    url: '/api/v1/autocomplete/experiences',
  },
  languageSearch: {
    url: '/api/v1/autocomplete/languages',
  },
  userSearch: {
    url: `/api/v1/autocomplete/imob-users`,
    name: 'userSearch',
  },
  opportunitySearch: {
    url: '/api/v1/autocomplete/search-opportunities',
  },
  opportunityFieldSearch: {
    url: '/api/v1/autocomplete/search-opportunity-field',
  },
  jobStructure: {
    url: '/api/v1/job-structure/autocomplete/titles',
  },
  successorsTemplateSearch: {
    url: '/api/v1/autocomplete/successor',
  },
  peopleSearch: {
    url: '/api/v1/autocomplete/search-people',
  },
  industriesSearch: {
    url: '/api/v1/autocomplete/industries',
  },
  certificationSearch: {
    url: '/api/company/v1/certifications/autocomplete',
  },
};

export default autoCompleteTypes;
